var map = {
	"./android/Device": 988,
	"./androidtv/Device": 1175,
	"./arris/Device": 1180,
	"./hisense/Device": 1191,
	"./lg/Device": 1199,
	"./nagra/Device": 1208,
	"./netrange/Device": 1219,
	"./opera/Device": 1227,
	"./polaroid/Device": 1235,
	"./ps4/Device": 1243,
	"./samsung/Device": 1251,
	"./seirobotics/Device": 1259,
	"./sony/Device": 1264,
	"./stbcoship/Device": 1272,
	"./stbcoship9108/Device": 1276,
	"./stbhuawei/Device": 1280,
	"./stbkaon/Device": 1284,
	"./tizen/Device": 1287,
	"./web0s/Device": 1296,
	"./workstation/Device": 622,
	"./workstationChafari/Device": 1310,
	"./zeasn/Device": 1318,
	"./zte/Device": 1326
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 987
// module chunks = 0